export default __webpack_public_path__ + "static/media/closet4-480w.9f7c2165.avif";